import { MapPin } from "lucide-react";
import { SERVICE_AREAS } from "../data/site";

/* eslint-disable react/no-unescaped-entities */

export default function ServiceAreaSection() {
  // duplicate list so the marquee loops seamlessly
  const looped = [...SERVICE_AREAS, ...SERVICE_AREAS];
  return (
    <section data-testid="service-area-section" className="bg-stone-900 text-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-500">
              Where we build
            </div>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[1.02]">
              Austin + every<br />neighborhood around it.
            </h2>
            <p className="mt-5 text-stone-300 leading-relaxed">
              Texan Strong Builds serves Austin, TX, the surrounding suburbs and the Hill Country.
              If you can see the capitol or the Pedernales, our crews will come pour or plant.
            </p>
          </div>
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-stone-700 border border-stone-700 max-h-[480px] overflow-hidden">
              {SERVICE_AREAS.map((a) => (
                <div
                  key={a}
                  className="bg-stone-900 px-4 py-3 flex items-center gap-2 text-sm text-stone-200 hover:bg-stone-800 hover:text-white transition-colors"
                  data-testid={`area-${a.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <MapPin size={12} className="text-red-500" />
                  {a}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 overflow-hidden border-y border-stone-800 py-4">
        <div className="marquee-track flex gap-10 whitespace-nowrap will-change-transform">
          {looped.map((a, i) => (
            <span key={`${a}-${i}`} className="text-2xl md:text-3xl font-display font-black tracking-tighter text-stone-500">
              {a} <span className="text-red-600 mx-2">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
